var exports = {
  "q": "ShopPrice.module__price___N0d1c0",
  "N": "ShopPrice.module__note___N0d1c0",
};

module.exports = exports;
